import { brandMark } from '@wm/brand';

/** The brand mark (shared with the Keycloak theme through @wm/brand). */
export function BrandMark({ size }: { size: number }) {
  const { tile, leaf, stem, ring } = brandMark;
  const grid = brandMark.size;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${grid} ${grid}`} aria-hidden>
      <rect width={grid} height={grid} rx={tile.rx} fill={tile.fill} />
      <path d={leaf.d} fill={leaf.fill} />
      <path
        d={stem.d}
        fill="none"
        stroke={stem.stroke}
        strokeWidth={stem.strokeWidth}
        strokeLinecap="round"
      />
      <circle
        cx={ring.cx}
        cy={ring.cy}
        r={ring.r}
        fill="none"
        stroke={ring.stroke}
        strokeWidth={ring.strokeWidth}
      />
    </svg>
  );
}
